import Event from '../../core/Event';

export default class OrderProductsGetFailed extends Event {
    public static type = 'OrderProductsGetFailed';

    constructor() {
        super(OrderProductsGetFailed.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/products/events/OrderProductsGetFailed.ts